<script>
    import { gmapApi } from 'vue2-google-maps';

    export default {
        name: "HelperMixin",
        data() {
            return {
                google: gmapApi,
                listDesignColor:{
                    0:
                    {
                        color: '#629F87',
                        border: '#8BBFAB',
                        background: 'rgba(211, 235, 225, 0.87)'
                    },
                    1:
                    {
                        color: '#8D8FA7',
                        border: 'rgba(99, 149, 180, 0.78)',
                        background: 'rgba(176, 202, 227, 0.52)'
                    },
                    2:
                    {
                        color: '#5F6DB4',
                        border: '#AFB6E2',
                        background: '#EEECFC'
                    },
                    3:
                    {
                        color: '#5F6DB4',
                        border: '#E8CDCA',
                        background: 'rgba(255, 231, 229, 0.87)'
                    },
                },
            }
        },
        methods: {
            createRespondentFromOffline() {
                var _this = this;
                if (this.$store.getters["online"]) {
                    this.$gmapApiPromiseLazy().then(() => {
                        var geocoder = new google.maps.Geocoder();
                        var respondentsOffline = _this.$store.getters["offlineLocations"];
                        for (var i = 0; i < respondentsOffline.length; i++) {
                            if (typeof respondentsOffline[i].is_processing == 'undefined' || !respondentsOffline[i].is_processing) {
                                respondentsOffline[i].is_processing = true;
                                _this.$store.dispatch('saveOfflineLocation', {
                                    offlineLocation: respondentsOffline[i]
                                });
                                (function(respondent) {
                                    geocoder.geocode({
                                        'address': respondent.location.full_address
                                    }, function(results, status) {
                                        if (status == 'OK') {
                                            respondent.location.lat = results[0].geometry.location.lat();
                                            respondent.location.lng = results[0].geometry.location.lng();
                                            let config = {
                                                headers: {
                                                    'Authorization': `Bearer ${_this.$store.getters["token"]}`,
                                                }
                                            };
                                            axios.post(
                                                '/api/v1/campaign/' + respondent.offline_campaign_id + '/respondent/create',
                                                respondent,
                                                config
                                            ).then(_this.consumeCreateRespondentFromOffline, _this.errorconsumeCreateRespondentFromOffline);
                                        } else {
                                            respondent.status = 'error';
                                            respondent.error_reason = status;
                                            respondent.is_processing = false;
                                            _this.$store.dispatch('saveOfflineLocation', {
                                                offlineLocation: respondent
                                            });
                                            _this.$store.dispatch('refreshOfflineLocations');
                                        }
                                    });
                                })(respondentsOffline[i]);
                            }
                            
                        
                        }
                    });
                
                }
            },

            consumeCreateRespondentFromOffline: function (response) {
                var reqData = JSON.parse(response.config.data)
                localStorage.removeItem('offlineLocationToProcess' + reqData.time_added_offline);
                this.$store.dispatch('refreshOfflineLocations');
                this.$root.$emit('get-campaign-locations');
            },

            errorconsumeCreateRespondentFromOffline: function (error) {
                
            },

            checkAppInstalled() {
                window.addEventListener("beforeinstallprompt", e => {
                    e.preventDefault();
                    this.$store.dispatch('saveIsInstalledPWA', {
                        isInstalledPWA: false
                    });
                    this.$store.dispatch('saveDeferredPWA', {
                        deferredPWA: e
                    });
                    this.$root.$emit('can-show-install-app-fct');
                });
                window.addEventListener("appinstalled", () => {
                    this.$store.dispatch('saveDeferredPWA', {
                        deferredPWA: null
                    });
                    this.$store.dispatch('saveIsInstalledPWA', {
                        isInstalledPWA: true
                    });
                    this.$root.$emit('can-show-install-app-fct');
                });

                if (window.matchMedia('(display-mode: standalone)').matches) {
                    this.$store.dispatch('saveDeferredPWA', {
                        deferredPWA: null
                    });
                    this.$store.dispatch('saveIsInstalledPWA', {
                        isInstalledPWA: true
                    });
                    this.$root.$emit('can-show-install-app-fct');
                }
            },

            setCookie(cname, cvalue, exdays) {
                const d = new Date();
                d.setTime(d.getTime() + (exdays*24*60*60*1000));
                let expires = "expires="+ d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },

            getCookie(cname) {
                let name = cname + "=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for(let i = 0; i <ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                    }
                }
                return "";
            },

            checkCookie(cname) {
                let cnameCookie = this.getCookie(cname);
                if (cnameCookie != "") {
                    return true;
                } else {
                    return false;
                }
            },

            parseDate(date) {
                var jsDate =  new Date(date + 'Z');
                return jsDate.getFullYear() + '-' + ('0' + (jsDate.getMonth()+1)).slice(-2) + '-' + ('0' + jsDate.getDate()).slice(-2) +
                ' ' + ('0' + jsDate.getHours()).slice(-2) + ':' + ('0' + jsDate.getMinutes()).slice(-2)
            },

            calculateColorListing(index) {
                return index%4;
            },

            detectMob() {
                const toMatch = [
                    /Android/i,
                    /webOS/i,
                    /iPhone/i,
                    /iPad/i,
                    /iPod/i,
                    /BlackBerry/i,
                    /Windows Phone/i
                ];

                return toMatch.some((toMatchItem) => {
                    return navigator.userAgent.match(toMatchItem);
                });
            },
            
            copyToClipboard(text) {
                if (window.clipboardData && window.clipboardData.setData) {
                    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
                    return clipboardData.setData("Text", text);

                }
                else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                    var textarea = document.createElement("textarea");
                    textarea.textContent = text;
                    textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
                    document.body.appendChild(textarea);
                    textarea.select();
                    try {
                        return document.execCommand("copy");  // Security exception may be thrown by some browsers.
                    }
                    catch (ex) {
                        console.warn("Copy to clipboard failed.", ex);
                        return false;
                    }
                    finally {
                        document.body.removeChild(textarea);
                    }
                }
            },

            copyToClipboardModal(str) {
                const el = document.createElement('textarea');
                el.value = str;
                document.getElementById('copy').appendChild(el);
                el.select();
                document.execCommand('Copy');
                document.getElementById('copy').removeChild(el);
            },

            goto(page, params = {}) {
                this.$router.push({ name: page, params: params});
            },

            capitalize(string) {
                if (typeof string != 'undefined') {
                    return string.charAt(0).toUpperCase() + string.slice(1);
                }
                 return '';
            },
            
            // Check if error key exists
            hasError: function (errorsBag, key) {
                if (errorsBag[key].length > 0) {
                    var element = document.getElementById(key);
                    if (element) {
                        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
                    }
                }
                return errorsBag[key].length > 0;
            },

            trimText(str, size = null) {
                size = size ? size : 15;
                if (typeof str == 'undefined') {
                    return '';
                }
                if(str.length > size) {
                    return str.substring(0, size) + '[...]';
                } else {
                    return str;
                }
            },

            log(value) {
                console.log(value);
            },

            isOwner(owner_id) {
                if (this.$store.getters["user"] == null) {
                    return false;
                }
                return owner_id == this.$store.getters["user"]._id;
            },

            addData(data) {
                if (this.$store.getters["user"] === null) {
                    this.$store.dispatch('saveShowTooltipAddMarker', {
                        showTooltipAddMarker: false
                    });
                }
                this.$store.dispatch('saveToken', {
                    token: data.token.access_token,
                    remember: true
                });
                this.$store.dispatch('saveUser', {
                    user: data.user
                }).then(()=> {
                    if (typeof this.name != "undefined") { 
                        this.name = data.user.name;
                    }
                });
                this.$store.dispatch('saveCampaignsList', {
                    campaignsList: data.campaigns
                });
                this.$store.dispatch('saveAlerts', {
                    alerts: data.alerts
                }).then(()=> {
                    if (typeof this.getNotifications == "function") { 
                        this.getNotifications();
                    }
                });
                if (typeof this.$route.params.campaign_id != 'undefined') {
                    var camp_id = this.$route.params.campaign_id;
                    var camps = data.campaigns.filter(function(el) {
                        return el._id == camp_id;
                    });
                    
                    if (camps.length == 0) {
                        this.$store.dispatch('saveIsLoading', {
                            isLoading: false
                        });
                        this.goto('not-found', {});
                        return false;
                    }
                    if (camps[0].owner_id != data.user._id && camps[0].status == 'inactive') {
                        this.$store.dispatch('saveIsLoading', {
                            isLoading: false
                        });
                        this.goto('campaign_list');
                        return false;
                    }

                    this.$store.dispatch('saveCurrentCampaign', {
                        currentCampaign: camps[0]
                    }).then(()=> {
                        if (typeof this.mapAnswersModelsFilter == "function") { 
                            this.mapAnswersModelsFilter();
                        }
                        if (typeof this.setChartsData == "function") {
                            this.setChartsData();
                        }
                        if (typeof this.questionsTmp != "undefined") {
                            this.questionsTmp = JSON.parse(JSON.stringify(camps[0].questions));
                        }
                    });

                    if (this.$route.name == 'campaign-map') {
                        if (typeof this.headerPageData != 'undefined') {
                            this.headerPageData.title = camps[0].name;
                            this.headerPageData.settings.campaign = camps[0];
                            this.tmpMarker = {
                                lat: camps[0].location.geometry.coordinates[1],
                                lng: camps[0].location.geometry.coordinates[0],
                                full_address: camps[0].location.properties.full_address,
                            };
                            this.$store.dispatch('saveCurrentLocation', {
                                currentLocation: this.tmpMarker
                            });
                            this.geolocate();
                        }
                    } else if (this.$route.name == 'add-location') {
                        if (typeof this.headerPageData != 'undefined') {
                            this.headerPageData.title = camps[0].name;
                            this.headerPageData.settings.campaign = camps[0];
                        }
                        
                        if (typeof this.form != 'undefined' && typeof camps[0].questions != 'undefined') {
                            for (var i = 0; i < camps[0].questions.length; i++) {
                                if ( camps[0].questions[i].type == 'single') {
                                    this.form.answers[camps[0].questions[i]._id] = '';   
                                } else {
                                    this.form.answers[camps[0].questions[i]._id] = [];
                                }
                            }
                        }
                    } else if (this.$route.name == 'campaign-settings') {
                        if (typeof this.headerPageData != 'undefined') {
                            this.headerPageData.title = camps[0].name;
                            this.headerPageData.settings.campaign = camps[0];
                        }
                    } else if (this.$route.name == 'campaign-teams') {
                        if (typeof this.headerPageData != 'undefined') {
                            this.headerPageData.title = camps[0].name;
                            this.headerPageData.settings.campaign = camps[0];
                        }
                    } else if (this.$route.name == 'campaign-locations') {
                        if (typeof this.headerPageData != 'undefined') {
                            this.headerPageData.title = camps[0].name;
                            this.headerPageData.settings.campaign = camps[0];
                            this.$root.$emit('get-campaign-locations');
                        }
                    } else if (this.$route.name == 'campaign-reports') {
                        if (typeof this.headerPageData != 'undefined') {
                            this.headerPageData.title = camps[0].name;
                            this.headerPageData.settings.campaign = camps[0];
                        }
                    }
                }
            },

            refreshData() {
                if (performance.navigation.type == 1 || performance.navigation.type == 0) {
                    this.$store.dispatch('saveIsLoading', {
                        isLoading: true
                    });
                    let config = {
                        headers: {
                            'Authorization': `Bearer ${this.$store.getters["token"]}`,
                        }
                    };
                    axios.post(
                        '/api/v1/user/refresh',
                        {},
                        config
                    ).then( (response) => {
                        
                        this.addData(response.data.data);
                        
                        localStorage.refreshData = JSON.stringify(response.data.data);

                        this.$store.dispatch('saveIsLoading', {
                            isLoading: false
                        });
                    }).catch( (error)=> {
                        if (
                            typeof error.message == 'undefined' ||
                            (typeof error.message != 'undefined' && error.message != 'Network Error')
                        ) {
                            this.$store.dispatch('forceLogout').then(() => {
                                this.$router.replace({ name: "login"});
                            });
                        } else {
                            if (localStorage.refreshData) {
                                this.addData(JSON.parse(localStorage.refreshData));
                            }
                        }
                        this.$store.dispatch('saveIsLoading', {
                            isLoading: false
                        });
                    });
                }
            },
        },
        computed: {
            currentRoute() {
                return this.$route.name;
            }
        },
    }
</script>
